import React, { useState, useEffect } from 'react';
import { PageHeader, StatCard, Card } from '../../components/UI';
import api from '../../utils/api';

export default function Analytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/analytics').then(r => { if (r.data.success) setData(r.data); }).finally(() => setLoading(false));
  }, []);

  const m = data?.messages || {};
  const c = data?.contacts || {};
  const total = m.month || 1;
  const bars = [
    { label: 'Delivered', val: Math.round((m.delivered / total) * 100) || 0, color: 'var(--green)' },
    { label: 'Read', val: Math.round((m.read / total) * 100) || 0, color: '#4da8ff' },
    { label: 'Failed', val: Math.round((m.failed / total) * 100) || 0, color: '#ff6b6b' },
  ];

  return (
    <div>
      <PageHeader title="Analytics" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: 16, marginBottom: 24 }}>
        <StatCard icon="📤" value={m.today?.toLocaleString() ?? '—'} label="Sent Today" />
        <StatCard icon="📅" value={m.month?.toLocaleString() ?? '—'} label="Sent This Month" />
        <StatCard icon="✔✔" value={m.delivered?.toLocaleString() ?? '—'} label="Delivered" />
        <StatCard icon="🔵" value={m.read?.toLocaleString() ?? '—'} label="Read" color="#4da8ff" />
        <StatCard icon="❌" value={m.failed?.toLocaleString() ?? '—'} label="Failed" color="#ff6b6b" />
        <StatCard icon="🔌" value={data?.widget?.leads_month ?? '—'} label="Widget Leads" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 24 }}>
        <Card title="👥 Contact Analytics">
          {[['Total Contacts', c.total?.toLocaleString(), 'var(--green)'], ['New This Month', c.new_month, null], ['Hot Leads', c.hot_leads, '#ff6b6b'], ['Warm Leads', c.warm_leads, '#ffd700'], ['Closed Deals', c.closed, 'var(--green)']].map(([label, val, color]) => (
            <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
              <span style={{ color: 'var(--text-muted)' }}>{label}</span>
              <span style={{ fontWeight: 700, color: color || 'var(--text)' }}>{val ?? '—'}</span>
            </div>
          ))}
        </Card>

        <Card title="📤 Campaign Analytics">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid var(--border)', fontSize: 13, marginBottom: 8 }}>
            <span style={{ color: 'var(--text-muted)' }}>Total Campaigns</span>
            <span style={{ fontWeight: 700, color: 'var(--green)' }}>{data?.campaigns?.total ?? '—'}</span>
          </div>
          {data?.campaigns?.recent?.length ? data.campaigns.recent.map(camp => (
            <div key={camp.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
              <span style={{ color: 'var(--text-secondary)' }}>{camp.name}</span>
              <span style={{ color: 'var(--green)' }}>{camp.total_sent || 0} sent</span>
            </div>
          )) : <div style={{ color: 'var(--text-muted)', fontSize: 13, padding: '16px 0', textAlign: 'center' }}>No campaigns yet</div>}
        </Card>
      </div>

      <Card title="📊 Message Delivery Rates">
        {loading ? <div style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 20 }}>Loading...</div> : bars.map(b => (
          <div key={b.label} style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
            <span style={{ fontSize: 12, color: 'var(--text-muted)', minWidth: 80 }}>{b.label}</span>
            <div style={{ flex: 1, background: 'var(--bg)', borderRadius: 100, height: 10, overflow: 'hidden' }}>
              <div style={{ height: '100%', background: b.color, borderRadius: 100, width: `${b.val}%`, transition: 'width 0.6s ease' }} />
            </div>
            <span style={{ fontSize: 12, color: b.color, minWidth: 36, textAlign: 'right', fontWeight: 600 }}>{b.val}%</span>
          </div>
        ))}
      </Card>
    </div>
  );
}